import { Injectable, Provider } from '@angular/core';
import { DateAdapter as MatDateAdapter, NativeDateAdapter } from '@angular/material/core';


@Injectable({ providedIn: 'root' })
export class DateAdapter extends NativeDateAdapter {
  public override format(date: Date, displayFormat: Object): string {
    if (date && displayFormat &&
      displayFormat['year'] === '2-digit' &&
      displayFormat['month'] === 'short' &&
      displayFormat['day'] === '2-digit') {
      const dtf = new Intl.DateTimeFormat(this.locale, displayFormat);

      const parts = dtf.formatToParts(date);
      const day = parts.find(p => p.type === 'day');
      const month = parts.find(p => p.type === 'month');
      const year = parts.find(p => p.type == 'year');

      return `${day.value}.${month.value}.${year.value}`;
    }

    return super.format(date, displayFormat);
  }
}

export function provideDateAdapter(): Provider {
  return {
    provide: MatDateAdapter,
    useExisting: DateAdapter
  };
}
